import { Icon as ModuleIcon } from 'modules/icon';
import React from 'react';

export const Icon = {
  ...ModuleIcon,
  Category: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 305.6 305.6'>
      <defs>
        <style />
      </defs>
      <g transform='translate(-957.717 -1186.526)'>
        <g transform='translate(957.717 1186.526)'>
          <path
            className='M1088.747,1330.629H970'
            d='M1088.747,1330.629H970.777a13.056,13.056,0,0,1-13.06-13.06V1199.586a13.056,13.056,0,0,1,13.06-13.06h117.97a13.056,13.056,0,0,1,13.06,13.06v117.983a13.056,13.056,0,0,1-13.06,13.06Zm-104.91-26.119h91.85v-91.864h-91.85v91.864Z'
            transform='translate(-957.718 -1186.526)'
          />
        </g>
        <g transform='translate(1119.228 1186.526)'>
          <path
            className='M1088.747,1330.629H970'
            d='M1101.113,1330.629H983.144a13.056,13.056,0,0,1-13.06-13.06V1199.586a13.056,13.056,0,0,1,13.06-13.06h117.97a13.056,13.056,0,0,1,13.06,13.06v117.983a13.056,13.056,0,0,1-13.06,13.06ZM996.2,1304.51h91.85v-91.864H996.2v91.864Z'
            transform='translate(-970.084 -1186.526)'
          />
        </g>
        <g transform='translate(957.717 1348.036)'>
          <path
            className='M1088.747,1330.629H970'
            d='M1088.747,1342.982H970.777a13.048,13.048,0,0,1-13.06-13.06V1211.952a13.048,13.048,0,0,1,13.06-13.06h117.97a13.048,13.048,0,0,1,13.06,13.06v117.971a13.048,13.048,0,0,1-13.06,13.06Zm-104.91-26.119h91.85v-91.851h-91.85v91.851Z'
            transform='translate(-957.718 -1198.893)'
          />
        </g>
        <g transform='translate(1119.228 1348.036)'>
          <path
            className='M1088.747,1330.629H970'
            d='M1101.113,1342.982H983.144a13.048,13.048,0,0,1-13.06-13.06V1211.952a13.048,13.048,0,0,1,13.06-13.06h117.97a13.048,13.048,0,0,1,13.06,13.06v117.971a13.048,13.048,0,0,1-13.06,13.06ZM996.2,1316.863h91.85v-91.851H996.2v91.851Z'
            transform='translate(-970.084 -1198.893)'
          />
        </g>
      </g>
    </svg>
  ),
  Product: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 372.564 341.857'>
      <defs></defs>
      <path
        className='341.857'
        d='M178.923,339.3,9.707,262.379a16.513,16.513,0,0,1-9.7-15.067V98.085c-.009-.305-.009-.61,0-.917v-3.69a16.5,16.5,0,0,1,9.7-15.066L178.923,1.478a16.635,16.635,0,0,1,13.708,0L361.862,78.412a16.556,16.556,0,0,1,9.7,15.066V97.45c0,.105,0,.212,0,.317V247.312a16.569,16.569,0,0,1-9.7,15.067L192.631,339.3a16.965,16.965,0,0,1-6.854,1.489A16.613,16.613,0,0,1,178.923,339.3Zm23.41-148.6V298.511l136.12-61.86V123.322l-136.93,62.236A16.561,16.561,0,0,1,202.333,190.692ZM33.117,236.651l136.1,61.859V190.692a16.584,16.584,0,0,1,.809-5.136L33.117,123.323Zm152.659-80.313,56.755-25.791-133.753-60.8-56.762,25.8Zm76.757-34.881,57.016-25.91L185.776,34.74l-57,25.913Z'
        transform='translate(0.5 0.572)'
      />
    </svg>
  ),
  DragPoint: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.5 15.333'>
      <defs></defs>
      <g transform='translate(-230.207 -1187.226)'>
        <path
          className='a'
          d='M244.707,1189.226h-13.5a1,1,0,1,1,0-2h13.5a1,1,0,0,1,0,2Z'
        />
        <path
          className='a'
          d='M244.707,1202.559h-13.5a1,1,0,1,1,0-2h13.5a1,1,0,0,1,0,2Z'
        />
        <path
          className='a'
          d='M244.707,1195.893h-13.5a1,1,0,1,1,0-2h13.5a1,1,0,0,1,0,2Z'
        />
      </g>
    </svg>
  ),
  Plus: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.875 23.875'>
      <defs></defs>
      <g transform='translate(-222.432 -753.052)'>
        <path
          className='a'
          d='M234.367,776.927a1,1,0,0,1-1-1V754.052a1,1,0,0,1,2,0v21.875a1,1,0,0,1-1,1Z'
        />
        <path
          className='a'
          d='M245.307,765.989H223.432a1,1,0,0,1,0-2h21.875a1,1,0,0,1,0,2Z'
        />
      </g>
    </svg>
  ),
  Minus: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2'>
      <path className='a' d='M19,13H5V11H19Z' transform='translate(-5 -11)' />
    </svg>
  ),
  Cart: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 31.399 26'>
      <defs></defs>
      <g transform='translate(-325 -54)'>
        <g transform='translate(-203.434 -1505.269)'>
          <g transform='translate(534.381 1563.933)'>
            <path
              className='a'
              d='M554.283,1577.005H537.646a1.237,1.237,0,0,1-1.195-.909l-3.17-11.493a1.238,1.238,0,0,1,1.195-1.567h22.977a1.238,1.238,0,0,1,1.192,1.567l-3.17,11.493a1.235,1.235,0,0,1-1.192.909Zm-15.694-2.476h14.752l2.485-9.017H536.1l2.487,9.017Z'
              transform='translate(-533.238 -1563.037)'
            />
          </g>
          <g transform='translate(528.434 1559.269)'>
            <path
              className='a'
              d='M538.787,1577.9a1.236,1.236,0,0,1-1.192-.91l-4.13-15.078-3.846-.167a1.242,1.242,0,0,1-1.183-1.291,1.2,1.2,0,0,1,1.292-1.183l4.746.208a1.237,1.237,0,0,1,1.14.909l4.37,15.948a1.24,1.24,0,0,1-.868,1.521,1.256,1.256,0,0,1-.329.043Z'
              transform='translate(-528.434 -1559.269)'
            />
          </g>
          <g transform='translate(538.339 1578.46)'>
            <path
              className='a'
              d='M539.839,1581.58a3.4,3.4,0,1,1,3.4-3.4,3.408,3.408,0,0,1-3.4,3.4Zm0-4.333a.928.928,0,1,0,.929.928.929.929,0,0,0-.929-.928Z'
              transform='translate(-536.435 -1574.772)'
            />
          </g>
          <g transform='translate(548.657 1578.46)'>
            <path
              className='a'
              d='M548.174,1581.58a3.4,3.4,0,1,1,3.4-3.4,3.407,3.407,0,0,1-3.4,3.4Zm0-4.333a.928.928,0,1,0,.929.928.928.928,0,0,0-.929-.928Z'
              transform='translate(-544.77 -1574.772)'
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  Collection: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25.207 24'>
      {' '}
      <g transform='translate(-1447.1 -1495.888)'>
        <path
          className='a'
          d='M1459.744,1510.888a1,1,0,0,1-.488-.128l-11.645-6.523a1,1,0,0,1,0-1.744l11.561-6.477a1,1,0,0,1,.978,0l11.645,6.522a1,1,0,0,1,0,1.744l-11.561,6.478a1,1,0,0,1-.49.128Zm-9.6-7.523,9.6,5.376,9.516-5.331-9.6-5.376-9.516,5.331Z'
        />
        <path
          className='a'
          d='M1459.744,1515.388a1,1,0,0,1-.488-.128l-11.645-6.523a1,1,0,0,1,.977-1.744l11.156,6.248,11.072-6.2a1,1,0,1,1,.979,1.744l-11.561,6.478a1,1,0,0,1-.49.128Z'
        />
        <path
          className='a'
          d='M1459.744,1519.888a1,1,0,0,1-.488-.128l-11.645-6.523a1,1,0,0,1,.977-1.744l11.156,6.248,11.072-6.2a1,1,0,1,1,.979,1.744l-11.561,6.478a1,1,0,0,1-.49.128Z'
        />
      </g>
    </svg>
  ),
  Visible: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24.032 17.75'>
      <defs></defs>
      <path
        className='a'
        d='M5366.05,37.687a1,1,0,0,1,0-.622,12.18,12.18,0,0,1,22.927,0,.983.983,0,0,1,0,.622,12.181,12.181,0,0,1-22.927,0Zm2.008-.311a10.2,10.2,0,0,0,18.912,0,10.2,10.2,0,0,0-18.912,0Zm4.037,0a1,1,0,1,1,2,0,3.417,3.417,0,1,0,3.417-3.416,1,1,0,1,1,0-2,5.417,5.417,0,1,1-5.418,5.417Z'
        transform='translate(-5365.498 -28.5)'
      />
    </svg>
  ),
  Invisible: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24.031 17.75'>
      <defs></defs>
      <path
        className='a'
        d='M5366.051,37.687a.976.976,0,0,1,0-.622,11.475,11.475,0,0,1,4.083-5.654l-.458-.458a1,1,0,0,1,1.414-1.415l.792.792a12.457,12.457,0,0,1,5.633-1.33,11.913,11.913,0,0,1,11.465,8.065,1,1,0,0,1,0,.622,11.481,11.481,0,0,1-4.086,5.655l.456.456a1,1,0,1,1-1.413,1.413l-.79-.79a12.466,12.466,0,0,1-5.631,1.328A11.905,11.905,0,0,1,5366.051,37.687Zm2.006-.311a9.941,9.941,0,0,0,9.457,6.374,10.517,10.517,0,0,0,4.126-.833l-10.073-10.073A9.516,9.516,0,0,0,5368.057,37.376Zm15.4,4.533a9.516,9.516,0,0,0,3.512-4.533A9.941,9.941,0,0,0,5377.513,31a10.51,10.51,0,0,0-4.128.835Zm-11.364-4.535a1,1,0,1,1,2,0,3.421,3.421,0,0,0,3.419,3.418,1,1,0,0,1,0,2A5.425,5.425,0,0,1,5372.095,37.374Zm8.833,0a3.418,3.418,0,0,0-3.414-3.416,1,1,0,1,1,0-2,5.421,5.421,0,0,1,5.414,5.415,1,1,0,1,1-2,0Z'
        transform='translate(-5365.498 -28.5)'
      />
    </svg>
  ),
  Dashboard: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26.25 26.25'>
      <path
        className='a'
        d='M3,17.583H14.667V3H3ZM3,29.25H14.667V20.5H3Zm14.583,0H29.25V14.667H17.583Zm0-26.25v8.75H29.25V3Z'
        transform='translate(-3 -3)'
      />
    </svg>
  ),
  Logout: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21.006 23.577'>
      <g transform='translate(-162.637 -691.404)'>
        <path
          className='a'
          d='M173.141,700.679a1,1,0,0,1-1-1V692.4a1,1,0,0,1,2,0v7.275a1,1,0,0,1-1,1Z'
        />
        <path
          className='a'
          d='M173.141,714.981a10.5,10.5,0,0,1-3.453-20.413,1,1,0,0,1,.658,1.889,8.5,8.5,0,1,0,5.588,0,1,1,0,1,1,.658-1.889,10.5,10.5,0,0,1-3.451,20.413Z'
        />
      </g>
    </svg>
  ),
  Trade: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 25.999'>
      <g transform='translate(-284.127 -938.998)'>
        <g transform='translate(284.127 938.998)'>
          <path
            className='a'
            d='M297.148,965a13.013,13.013,0,0,1-.867-26,1.1,1.1,0,0,1,1.174,1.1v11.571h11.571a1.1,1.1,0,0,1,1.1,1.175A13.037,13.037,0,0,1,297.148,965Zm-1.9-23.655a10.809,10.809,0,1,0,12.533,12.533H296.352a1.1,1.1,0,0,1-1.1-1.1V941.342Z'
            transform='translate(-284.127 -938.998)'
          />
        </g>
        <g transform='translate(300.023 940.2)'>
          <path
            className='a'
            d='M306.2,949.283h-8.084a.5.5,0,0,1-.5-.5V940.7a.5.5,0,0,1,.5-.5,8.593,8.593,0,0,1,8.584,8.583.5.5,0,0,1-.5.5Zm-7.584-1h7.067a7.593,7.593,0,0,0-7.067-7.067v7.067Z'
            transform='translate(-297.617 -940.2)'
          />
        </g>
      </g>
    </svg>
  ),
  Wallet: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 18.833'>
      <g transform='translate(-468.131 -942.408)'>
        <g transform='translate(468.158 942.408)'>
          <path
            className='a'
            d='M491.466,961.241H470.825a2.669,2.669,0,0,1-2.667-2.667v-13.5a2.669,2.669,0,0,1,2.667-2.666h20.641a2.668,2.668,0,0,1,2.665,2.666v13.5a2.668,2.668,0,0,1-2.665,2.667Zm-20.641-16.588a.421.421,0,0,0-.421.42v13.5a.421.421,0,0,0,.421.421h20.641a.421.421,0,0,0,.419-.421v-13.5a.421.421,0,0,0-.419-.42Z'
            transform='translate(-468.158 -942.408)'
          />
        </g>
        <g transform='translate(468.131 947.411)'>
          <path
            className='a'
            d='M492.936,948.8H469.254a1.007,1.007,0,1,1,0-2h23.682a1.007,1.007,0,1,1,0,2Z'
            transform='translate(-468.131 -946.799)'
          />
        </g>
        <g transform='translate(472.72 953.177)'>
          <path
            className='a'
            d='M474.529,953.859h-2.361v-2h2.361v2Z'
            transform='translate(-472.168 -951.859)'
          />
        </g>
      </g>
    </svg>
  ),
  Exchange: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 23.019'>
      <g transform='translate(-589.934 -1621.091)'>
        <g transform='translate(604.233 1634.781)'>
          <path
            className='a'
            d='M612.23,1638.152H604.8a1,1,0,0,1-.836-.451l-1.949-2.972a1,1,0,0,1,1.672-1.1l1.654,2.52h6.89a1,1,0,0,1,0,2Z'
            transform='translate(-601.849 -1633.181)'
          />
        </g>
        <g transform='translate(589.934 1625.444)'>
          <path
            className='a'
            d='M599.934,1630.015a1,1,0,0,1-.856-.483l-1.576-2.6h-6.568a1,1,0,0,1,0-2h7.132a1,1,0,0,1,.856.482l1.867,3.083a1,1,0,0,1-.855,1.518Z'
            transform='translate(-589.934 -1624.932)'
          />
        </g>
        <g transform='translate(589.934 1625.986)'>
          <path
            className='a'
            d='M598.9,1638.152h-7.862a1,1,0,1,1,0-2h7.238l7.1-10.735a1.132,1.132,0,0,1,.946-.485h8.191a1,1,0,1,1,0,2h-7.567l-7.1,10.735a1.132,1.132,0,0,1-.946.485Z'
            transform='translate(-589.934 -1624.932)'
          />
        </g>
        <g transform='translate(610.067 1621.091)'>
          <path
            className='a'
            d='M608.684,1630.833a1,1,0,0,1-.707-1.707l3.162-3.164-3.162-3.164a1,1,0,0,1,1.414-1.414l3.867,3.871a1,1,0,0,1,0,1.414l-3.867,3.871a1,1,0,0,1-.707.293Z'
            transform='translate(-607.684 -1621.091)'
          />
        </g>
        <g transform='translate(610.067 1634.368)'>
          <path
            className='a'
            d='M608.684,1642a1,1,0,0,1-.707-1.707l3.162-3.164-3.162-3.164a1,1,0,0,1,1.414-1.414l3.867,3.871a1,1,0,0,1,0,1.414l-3.867,3.871a1,1,0,0,1-.707.293Z'
            transform='translate(-607.684 -1632.258)'
          />
        </g>
      </g>
    </svg>
  ),
  ArrowDown: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 5'>
      <path className='a' d='M7,10l5,5,5-5Z' transform='translate(-7 -10)' />
    </svg>
  ),
  Deposit: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.971 20'>
      <g transform='translate(-653.084 -1805.117)'>
        <path
          className='a'
          d='M661.57,1825.117a.83.83,0,0,1-.65-.312l-7.654-9.564a.832.832,0,0,1,.65-1.352h3.189v-7.941a.832.832,0,0,1,.832-.832H665.2a.832.832,0,0,1,.832.832v7.941h3.189a.832.832,0,0,1,.649,1.352l-7.654,9.564a.832.832,0,0,1-.649.312Zm-5.924-9.564,5.924,7.4,5.922-7.4H665.2a.832.832,0,0,1-.832-.832v-7.941h-5.6v7.941a.831.831,0,0,1-.832.832Z'
        />
      </g>
    </svg>
  ),
  Withdraw: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.985 20'>
      <g transform='translate(-591.542 -1805.136)'>
        <path
          className='a'
          d='M603.669,1825.136H596.4a.832.832,0,0,1-.833-.833v-7.947h-3.192a.832.832,0,0,1-.649-1.353l7.66-9.572a.86.86,0,0,1,1.3,0l7.661,9.572a.832.832,0,0,1-.651,1.353H604.5v7.947a.832.832,0,0,1-.833.833Zm-6.439-1.665h5.606v-7.947a.832.832,0,0,1,.833-.833h2.293l-5.928-7.406-5.927,7.406H596.4a.832.832,0,0,1,.833.833v7.947Z'
          transform='translate(0 0)'
        />
      </g>
    </svg>
  ),
  Notification: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 29.901 30'>
      <g transform='translate(-590.036 -815.283)'>
        <g transform='translate(590.251 818.127)'>
          <path
            className='a'
            d='M591.48,842.238a1.276,1.276,0,0,1-1.137-1.854l.359-.7c1.1-2.129,1.434-2.771,1.99-9.977.559-7.184,5.48-12.2,11.971-12.2h.781a1.277,1.277,0,1,1,0,2.554h-.779c-5.183,0-8.969,3.954-9.427,9.842-.573,7.416-.943,8.393-2.27,10.955l-.346.676a1.284,1.284,0,0,1-1.143.7Z'
            transform='translate(-590.205 -817.51)'
          />
          <g transform='translate(12.955)'>
            <path
              className='a'
              d='M615.586,842.238a1.275,1.275,0,0,1-1.139-.7l-.35-.678c-1.322-2.562-1.693-3.538-2.267-10.953-.458-5.888-4.245-9.842-9.424-9.842h-.78a1.277,1.277,0,1,1,0-2.554h.778c6.49,0,11.415,5.015,11.973,12.2.559,7.2.89,7.847,1.991,9.977l.359.7a1.279,1.279,0,0,1-1.14,1.854Z'
              transform='translate(-600.348 -817.51)'
            />
          </g>
        </g>
        <g transform='translate(590.036 838.936)'>
          <path
            className='a'
            d='M618.66,837.768a1.3,1.3,0,0,1-.259-.027,65.772,65.772,0,0,0-26.83,0,1.277,1.277,0,0,1-.519-2.5,68.26,68.26,0,0,1,27.867,0,1.277,1.277,0,0,1-.259,2.527Z'
            transform='translate(-590.036 -833.804)'
          />
        </g>
        <g transform='translate(603.709 815.283)'>
          <path
            className='a'
            d='M602.019,820.417a1.276,1.276,0,0,1-1.277-1.277v-2.58a1.277,1.277,0,1,1,2.554,0v2.58a1.276,1.276,0,0,1-1.277,1.277Z'
            transform='translate(-600.742 -815.283)'
          />
        </g>
        <g transform='translate(601.168 840.188)'>
          <path
            className='a'
            d='M602.568,839.879a3.82,3.82,0,0,1-3.816-3.817,1.277,1.277,0,0,1,2.554,0,1.266,1.266,0,0,0,2.531,0,1.277,1.277,0,0,1,2.554,0,3.824,3.824,0,0,1-3.824,3.817Z'
            transform='translate(-598.752 -834.784)'
          />
        </g>
      </g>
    </svg>
  ),
  Setting: () => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.5028 10C17.5028 10.34 17.4728 10.66 17.4328 10.98L19.5428 12.63C19.7328 12.78 19.7828 13.05 19.6628 13.27L17.6628 16.73C17.5428 16.95 17.2828 17.04 17.0528 16.95L14.5628 15.95C14.0428 16.34 13.4828 16.68 12.8728 16.93L12.4928 19.58C12.4628 19.82 12.2528 20 12.0028 20H8.00277C7.75277 20 7.54277 19.82 7.51277 19.58L7.13277 16.93C6.52277 16.68 5.96277 16.35 5.44277 15.95L2.95277 16.95C2.73277 17.03 2.46277 16.95 2.34277 16.73L0.342769 13.27C0.222769 13.05 0.272769 12.78 0.462769 12.63L2.57277 10.98C2.53277 10.66 2.50277 10.33 2.50277 10C2.50277 9.67 2.53277 9.34 2.57277 9.02L0.462769 7.37C0.272769 7.22 0.212769 6.95 0.342769 6.73L2.34277 3.27C2.46277 3.05 2.72277 2.96 2.95277 3.05L5.44277 4.05C5.96277 3.66 6.52277 3.32 7.13277 3.07L7.51277 0.42C7.54277 0.18 7.75277 0 8.00277 0H12.0028C12.2528 0 12.4628 0.18 12.4928 0.42L12.8728 3.07C13.4828 3.32 14.0428 3.65 14.5628 4.05L17.0528 3.05C17.2728 2.97 17.5428 3.05 17.6628 3.27L19.6628 6.73C19.7828 6.95 19.7328 7.22 19.5428 7.37L17.4328 9.02C17.4728 9.34 17.5028 9.66 17.5028 10ZM6.50277 10C6.50277 11.93 8.07277 13.5 10.0028 13.5C11.9328 13.5 13.5028 11.93 13.5028 10C13.5028 8.07 11.9328 6.5 10.0028 6.5C8.07277 6.5 6.50277 8.07 6.50277 10Z'
        fill='black'
      />
    </svg>
  ),
  Up: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25.166 19.275'>
      <g transform='translate(-1814.174 -1807.501)'>
        <path
          className='a'
          d='M1820.307,1826.776h-5.133a1,1,0,0,1,0-2h4.668l11.033-13.079a1,1,0,0,1,.766-.355h6.379a1,1,0,0,1,0,2H1832.1l-11.035,13.079a.992.992,0,0,1-.763.355Z'
        />
        <path
          className='a'
          d='M1834.473,1817.243a1,1,0,0,1-.707-1.707l3.16-3.164-3.16-3.164a1,1,0,0,1,1.414-1.414l3.867,3.871a1,1,0,0,1,0,1.414l-3.867,3.871a1,1,0,0,1-.707.293Z'
        />
      </g>
    </svg>
  ),
  Down: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25.164 19.275'>
      <g transform='translate(-1875.518 -1807.501)'>
        <path
          className='a'
          d='M1899.361,1822.935h-6.379a.994.994,0,0,1-.763-.355l-11.035-13.079h-4.666a1,1,0,0,1,0-2h5.13a1,1,0,0,1,.766.355l11.033,13.079h5.914a1,1,0,0,1,0,2Z'
        />
        <path
          className='a'
          d='M1895.815,1826.776a1,1,0,0,1-.708-1.707l3.163-3.164-3.163-3.164a1,1,0,0,1,1.415-1.414l3.867,3.871a1,1,0,0,1,0,1.414l-3.867,3.871a1,1,0,0,1-.707.293Z'
        />
      </g>
    </svg>
  ),
  Copy: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.545 18'>
      <path
        className='a'
        d='M13.455,1H3.636A1.641,1.641,0,0,0,2,2.636V14.091H3.636V2.636h9.818Zm2.455,3.273h-9A1.641,1.641,0,0,0,5.273,5.909V17.364A1.641,1.641,0,0,0,6.909,19h9a1.641,1.641,0,0,0,1.636-1.636V5.909A1.641,1.641,0,0,0,15.909,4.273Zm0,13.091h-9V5.909h9Z'
        transform='translate(-2 -1)'
      />
    </svg>
  ),
  Update: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13.091 18'>
      <path
        className='a'
        d='M10.545,3.455V1L7.273,4.273l3.273,3.273V5.091A4.913,4.913,0,0,1,15.455,10a4.8,4.8,0,0,1-.573,2.291l1.195,1.195A6.534,6.534,0,0,0,10.545,3.455Zm0,11.455A4.913,4.913,0,0,1,5.636,10a4.8,4.8,0,0,1,.573-2.291L5.015,6.515a6.534,6.534,0,0,0,5.531,10.031V19l3.273-3.273-3.273-3.273Z'
        transform='translate(-4 -1)'
      />
    </svg>
  ),
  Mail: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 19'>
      <path
        d='M21.99,8a1.982,1.982,0,0,0-.94-1.7L12,1,2.95,6.3A1.991,1.991,0,0,0,2,8V18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2ZM12,13,3.74,7.84,12,3l8.26,4.84Z'
        transform='translate(-2 -1)'
      />
    </svg>
  ),
  VerifyMail: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 965.781 965.781'>
      <g transform='translate(-340.501 -241.5)'>
        <path
          className='a'
          d='M420.222,1207.281a79.809,79.809,0,0,1-79.721-79.706V694.407a15.6,15.6,0,0,0,.556-2.78,18.242,18.242,0,0,1,.819-4.068,18.969,18.969,0,0,1,1.6-3.76,13.393,13.393,0,0,0,.878-1.874,14.435,14.435,0,0,0,1.229-1.287,20.618,20.618,0,0,1,3.014-2.883,10.207,10.207,0,0,0,2.049-2.239l140.126-112.1a10.123,10.123,0,0,0,3.8-7.9V298.788c0-31.593,25.4-57.288,56.63-57.288H1095.6c31.227,0,56.629,25.7,56.629,57.288V555.511a10.124,10.124,0,0,0,3.805,7.9L1296.259,675.6a9.587,9.587,0,0,0,1.975,2.181,18.389,18.389,0,0,1,2.956,2.839,15.514,15.514,0,0,0,1.259,1.317,14.82,14.82,0,0,0,.819,1.756,19.711,19.711,0,0,1,1.639,3.834,17.772,17.772,0,0,1,.819,4.01,17.092,17.092,0,0,0,.556,2.883v433.153a79.8,79.8,0,0,1-79.707,79.706Zm711.3-133.834a20.7,20.7,0,0,1,14.647,35.339l-39.846,39.831a10.115,10.115,0,0,0,7.156,17.267h113.1a38.354,38.354,0,0,0,38.31-38.309V752.4a10.115,10.115,0,0,0-5.414-8.97,10.27,10.27,0,0,0-4.7-1.156,10.159,10.159,0,0,0-5.75,1.8L896.806,987.917a19.708,19.708,0,0,1-2.034,1.229c-27.978,15.014-50,21.7-71.38,21.7S780,1004.16,751.982,989.132a19.846,19.846,0,0,1-2.02-1.244L397.775,744.072a10.163,10.163,0,0,0-5.751-1.8,10.268,10.268,0,0,0-4.7,1.156,10.114,10.114,0,0,0-5.414,8.97v375.177a38.354,38.354,0,0,0,38.309,38.309H471.7a10.126,10.126,0,0,0,7.155-2.971l83.408-83.408a20.7,20.7,0,0,1,29.266,29.281L551.7,1148.617a10.115,10.115,0,0,0,7.141,17.267h97.734a10.126,10.126,0,0,0,7.155-2.971l83.408-83.408a20.7,20.7,0,0,1,29.266,29.281l-39.831,39.831a10.115,10.115,0,0,0,7.141,17.267h97.734a10.126,10.126,0,0,0,7.156-2.971l83.408-83.408a20.7,20.7,0,0,1,29.266,29.281l-39.831,39.831a10.114,10.114,0,0,0,7.156,17.267h97.719a10.1,10.1,0,0,0,7.156-2.971l83.409-83.408A20.58,20.58,0,0,1,1131.52,1073.447ZM551.2,282.9c-8.4,0-15.233,7.126-15.233,15.892v485.3a10.123,10.123,0,0,0,4.361,8.312L772.088,952.856a9.212,9.212,0,0,0,1.024.629c21.35,11.326,35.924,15.935,50.279,15.935s28.944-4.609,50.293-15.935a9.167,9.167,0,0,0,1.024-.629l231.758-160.451a10.122,10.122,0,0,0,4.361-8.312v-485.3c0-8.765-6.833-15.892-15.233-15.892ZM1162.337,624.33a10.111,10.111,0,0,0-10.112,10.112V741.424a10.105,10.105,0,0,0,5.429,8.955,9.987,9.987,0,0,0,4.683,1.156,10.193,10.193,0,0,0,5.766-1.785l71.687-49.635a10.118,10.118,0,0,0,.556-16.214l-71.687-57.362A10.113,10.113,0,0,0,1162.337,624.33Zm-677.876,0a10.11,10.11,0,0,0-6.321,2.21L406.452,683.9a10.118,10.118,0,0,0,.556,16.214L478.7,749.75a10.192,10.192,0,0,0,5.766,1.785,9.987,9.987,0,0,0,4.683-1.156,10.106,10.106,0,0,0,5.429-8.955V634.441a10.111,10.111,0,0,0-10.111-10.112Z'
          transform='translate(0)'
        />
        <path
          className='a'
          d='M476.793,484.63a20.507,20.507,0,0,1-14.633-6.073l-92.437-92.437a20.694,20.694,0,0,1,29.266-29.266L469.638,427.5a10.085,10.085,0,0,0,14.3,0l163.1-163.085A20.694,20.694,0,0,1,676.3,293.684L491.426,478.572A20.579,20.579,0,0,1,476.793,484.63Z'
          transform='translate(315.796 229.649)'
        />
      </g>
    </svg>
  ),
  PriceUp: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <path
        d='M4,12l1.41,1.41L11,7.83V20h2V7.83l5.58,5.59L20,12,12,4Z'
        transform='translate(-4 -4)'
      />
    </svg>
  ),
  PriceDown: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <path
        className='a'
        d='M20,12l-1.41-1.41L13,16.17V4H11V16.17L5.42,10.58,4,12l8,8Z'
        transform='translate(-4 -4)'
      />
    </svg>
  ),
  Menu: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 12'>
      <path
        d='M3,18H21V16H3Zm0-5H21V11H3ZM3,6V8H21V6Z'
        transform='translate(-3 -6)'
      />
    </svg>
  ),
  Account: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 17'>
      <path
        className='a'
        d='M3,4.889V18.111A1.888,1.888,0,0,0,4.889,20H18.111A1.894,1.894,0,0,0,20,18.111V4.889A1.894,1.894,0,0,0,18.111,3H4.889A1.888,1.888,0,0,0,3,4.889ZM14.333,8.667A2.833,2.833,0,1,1,11.5,5.833,2.83,2.83,0,0,1,14.333,8.667Zm-8.5,7.556c0-1.889,3.778-2.928,5.667-2.928s5.667,1.039,5.667,2.928v.944H5.833Z'
        transform='translate(-3 -3)'
      />
    </svg>
  ),
  Profile: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.13 17'>
      <path
        className='a'
        d='M108.963,1265.272a40.012,40.012,0,0,1-6.309-.5,2.04,2.04,0,0,1-1.57-1.741q-.092-.877-.177-1.761a2.3,2.3,0,0,1,1.152-2.12,15.915,15.915,0,0,1,4.268-1.335l-.024-.161a1.863,1.863,0,0,1-.7-1.191c-.014-.137-.03-.275-.046-.415a1.025,1.025,0,0,1-.615-.841l-.173-1.661a1.012,1.012,0,0,1,.219-.749,1.034,1.034,0,0,1,.174-.17l-.054-.5a3.137,3.137,0,0,1,.842-2.781,4.776,4.776,0,0,1,6.053.022,3.125,3.125,0,0,1,.816,2.755l-.012.138c-.014.126-.028.247-.042.365a.992.992,0,0,1,.17.167,1.019,1.019,0,0,1,.221.755l-.172,1.659a1.016,1.016,0,0,1-.618.842l-.051.432a1.828,1.828,0,0,1-.69,1.172l-.022.161a15.794,15.794,0,0,1,4.238,1.323,2.309,2.309,0,0,1,1.178,2.135l-.173,1.757a2.042,2.042,0,0,1-1.557,1.739,40.041,40.041,0,0,1-6.327.507Zm-2.645-10.663a.675.675,0,0,1,.1.025.714.714,0,0,1,.485.595c.043.364.085.724.124,1.087a.821.821,0,0,0,.325.335.709.709,0,0,1,.325.506l.162,1.159a.714.714,0,0,1-.623.813,14.536,14.536,0,0,0-4.519,1.3.876.876,0,0,0-.367.7c.055.589.115,1.17.174,1.752a.626.626,0,0,0,.394.479,38.577,38.577,0,0,0,12.148,0,.618.618,0,0,0,.378-.475l.173-1.749a.884.884,0,0,0-.394-.718,14.451,14.451,0,0,0-4.494-1.285.716.716,0,0,1-.623-.811l.167-1.167a.713.713,0,0,1,.323-.5.8.8,0,0,0,.32-.334l.129-1.092a.713.713,0,0,1,.485-.593.618.618,0,0,1,.1-.025l.082-.795a.688.688,0,0,1-.114-.064.718.718,0,0,1-.306-.676l.01-.071c.035-.292.069-.582.1-.874l.013-.146a1.782,1.782,0,0,0-.369-1.575,3.37,3.37,0,0,0-4.1-.023,1.788,1.788,0,0,0-.394,1.6l.122,1.093a.714.714,0,0,1-.31.673.621.621,0,0,1-.109.061l.082.795Z'
        transform='translate(-100.898 -1248.272)'
      />
    </svg>
  ),
  KYC: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13.909 17'>
      <path
        className='a'
        d='M9.955,1,3,4.091V8.727A9.616,9.616,0,0,0,9.955,18a9.616,9.616,0,0,0,6.955-9.273V4.091Zm0,8.492h5.409A8.272,8.272,0,0,1,9.955,16.4V9.5H4.545V5.1l5.409-2.4v6.8Z'
        transform='translate(-3 -1)'
      />
    </svg>
  ),
  CoinExchange: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22.932 23.744'>
      <g transform='translate(-1202.844 -1805.267)'>
        <path
          className='a'
          d='M1209.213,1829.011a1,1,0,0,1-.707-.293l-5.369-5.371a1,1,0,0,1,0-1.414l5.369-5.373a1,1,0,0,1,1.414,1.414l-4.662,4.666,4.662,4.664a1,1,0,0,1-.707,1.707Z'
        />
        <path
          className='a'
          d='M1205.3,1823.64a1,1,0,0,1,0-2l19.472,0a1,1,0,0,1,0,2l-19.472,0Z'
        />
        <path
          className='a'
          d='M1219.406,1818.011a1,1,0,0,1-.707-1.707l4.662-4.666-4.662-4.664a1,1,0,0,1,1.414-1.414l5.369,5.371a1,1,0,0,1,0,1.414l-5.369,5.373a1,1,0,0,1-.707.293Z'
        />
        <path
          className='a'
          d='M1203.844,1812.64a1,1,0,0,1,0-2l19.472,0a1,1,0,0,1,0,2l-19.472,0Z'
        />
      </g>
    </svg>
  ),
  Affiliate: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 28.773'>
      <path
        className='a'
        d='M24.667,22.338a4.206,4.206,0,0,0-2.831,1.112l-10.3-5.994a4.729,4.729,0,0,0,.13-1.011,4.729,4.729,0,0,0-.13-1.011L21.72,9.5a4.324,4.324,0,1,0-1.387-3.163,4.728,4.728,0,0,0,.13,1.011L10.28,13.281a4.333,4.333,0,1,0,0,6.327l10.284,6.009a4.075,4.075,0,0,0-.116.939,4.218,4.218,0,1,0,4.218-4.218Z'
        transform='translate(-3 -2)'
      />
    </svg>
  ),
  ArrowLeft: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <path
        className='a'
        d='M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z'
        transform='translate(-4 -4)'
      />
    </svg>
  ),
  Transfer: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24.113 22.721'>
      <g transform='translate(-161.082 -1867.895)'>
        <path d='M178.857,1877.637a1,1,0,0,1-.707-1.707l3.163-3.164-3.163-3.164a1,1,0,0,1,1.415-1.414l3.867,3.871a1,1,0,0,1,0,1.414l-3.867,3.871a1,1,0,0,1-.708.293Z' />
        <path d='M181.469,1890.615h-16.66a3.731,3.731,0,0,1-3.727-3.727v-11.417a3.731,3.731,0,0,1,3.727-3.727h6.166a.932.932,0,0,1,0,1.863h-6.166a1.866,1.866,0,0,0-1.864,1.864v11.417a1.866,1.866,0,0,0,1.864,1.864h16.66a1.866,1.866,0,0,0,1.863-1.864v-11.417a.932.932,0,1,1,1.863,0v11.417a3.731,3.731,0,0,1-3.726,3.727Z' />
        <path d='M165.7,1886.776a.969.969,0,0,1-.191-.018,1,1,0,0,1-.791-1.172,17.014,17.014,0,0,1,16.629-13.82,1,1,0,1,1,0,2,15.011,15.011,0,0,0-14.666,12.2,1,1,0,0,1-.981.81Z' />
      </g>
    </svg>
  ),
  Report: () => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 16C9.1 16 10 15.1 10 14V2C10 0.9 9.1 0 8 0C6.9 0 6 0.9 6 2V14C6 15.1 6.9 16 8 16ZM2 16C3.1 16 4 15.1 4 14V10C4 8.9 3.1 8 2 8C0.9 8 0 8.9 0 10V14C0 15.1 0.9 16 2 16ZM12 14V7C12 5.9 12.9 5 14 5C15.1 5 16 5.9 16 7V14C16 15.1 15.1 16 14 16C12.9 16 12 15.1 12 14Z'
        fill='black'
      />
    </svg>
  ),
  Table: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
      <path
        d='M20,2H4A2.006,2.006,0,0,0,2,4V20a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V4A2.006,2.006,0,0,0,20,2ZM8,20H4V16H8Zm0-6H4V10H8ZM8,8H4V4H8Zm6,12H10V16h4Zm0-6H10V10h4Zm0-6H10V4h4Zm6,12H16V16h4Zm0-6H16V10h4Zm0-6H16V4h4Z'
        transform='translate(-2 -2)'
      />
    </svg>
  ),
  Tree: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'>
      <path
        d='M17,16l-4-4V8.82a3,3,0,1,0-2,0V12L7,16H3v5H8V17.95l4-4.2,4,4.2V21h5V16Z'
        transform='translate(-3 -3)'
      />
    </svg>
  ),
  Leader: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
    >
      <path
        d='M15.49,9.63A11.792,11.792,0,0,0,12.06,2,12.188,12.188,0,0,0,8.51,9.63,13.867,13.867,0,0,1,12,12.26a14.358,14.358,0,0,1,3.49-2.63Zm-6.5,2.65c-.14-.1-.3-.19-.45-.29C8.69,12.1,8.85,12.18,8.99,12.28Zm6.42-.25c-.13.09-.27.16-.4.26C15.14,12.19,15.28,12.12,15.41,12.03ZM12,15.45A11.946,11.946,0,0,0,2,10a12.174,12.174,0,0,0,8.03,11.49A10.749,10.749,0,0,0,12,22a12.94,12.94,0,0,0,1.97-.51A12.174,12.174,0,0,0,22,10,11.946,11.946,0,0,0,12,15.45Z'
        transform='translate(-2 -2)'
      />
    </svg>
  ),
  ClaimIcon: () => (
    <svg
      width='22'
      height='20'
      viewBox='0 0 22 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M4 9H0V20H4V9Z' fill='#323232' />
      <path
        d='M15 1.25C15.65 0.49 16.66 0 17.7 0C19.55 0 21 1.45 21 3.3C21 5.57 18.09 8.2 15 11C11.91 8.19 9 5.56 9 3.3C9 1.45 10.45 0 12.3 0C13.34 0 14.35 0.49 15 1.25Z'
        fill='#323232'
      />
      <path
        d='M19 15H12L9.91 14.27L10.24 13.33L12 14H14.82C15.47 14 16 13.47 16 12.82C16 12.33 15.69 11.89 15.23 11.71L7.97 9H6V18.02L13 20L21.01 17C21 15.9 20.11 15 19 15Z'
        fill='#323232'
      />
    </svg>
  ),
  HistoryIcon: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z'
        fill='#323232'
      />
    </svg>
  ),
  TransactionIcon: () => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM13 4.5L16.5 8L13 11.5V9H9V7H13V4.5ZM7 15.5L3.5 12L7 8.5V11H11V13H7V15.5Z'
        fill='#323232'
      />
    </svg>
  ),
  GameManagementIcon: () => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0H8V8H0V0ZM10 0H18V8H10V0ZM0 10H8V18H0V10ZM15 10H13V13H10V15H13V18H15V15H18V13H15V10Z'
        fill='#323232'
      />
    </svg>
  ),
  MaintenanceIcon: () => (
    <svg
      width='23'
      height='22'
      viewBox='0 0 23 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.7 17.9998L13.6 8.89977C14.5 6.59977 14 3.89977 12.1 1.99977C10.1 -0.0002321 7.1 -0.400232 4.7 0.699768L9 4.99977L6 7.99977L1.6 3.69977C0.4 6.09977 0.9 9.09977 2.9 11.0998C4.8 12.9998 7.5 13.4998 9.8 12.5998L18.9 21.6998C19.3 22.0998 19.9 22.0998 20.3 21.6998L22.6 19.3998C23.1 18.9998 23.1 18.2998 22.7 17.9998Z'
        fill='#323232'
      />
    </svg>
  ),
  ChangePasswordIcon: () => (
    <svg
      width='16'
      height='21'
      viewBox='0 0 16 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H14C15.1 21 16 20.1 16 19V9C16 7.9 15.1 7 14 7ZM8 16C6.9 16 6 15.1 6 14C6 12.9 6.9 12 8 12C9.1 12 10 12.9 10 14C10 15.1 9.1 16 8 16ZM11.1 7H4.9V5C4.9 3.29 6.29 1.9 8 1.9C9.71 1.9 11.1 3.29 11.1 5V7Z'
        fill='#323232'
      />
    </svg>
  ),
  Transaction2Icon: () => (
    <svg
      width='20'
      height='14'
      viewBox='0 0 20 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.01 9H0V11H7.01V14L11 10L7.01 6V9ZM12.99 8V5H20V3H12.99V0L9 4L12.99 8Z'
        fill='#323232'
      />
    </svg>
  ),
  PlaceGameIcon: () => (
    <svg
      width='20'
      height='14'
      viewBox='0 0 20 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.5798 11.09L18.4898 3.43C18.2098 1.46 16.5198 0 14.5298 0H5.46982C3.47982 0 1.78982 1.46 1.50982 3.43L0.419821 11.09C0.199821 12.63 1.38982 14 2.93982 14C3.61982 14 4.25982 13.73 4.73982 13.25L6.99982 11H12.9998L15.2498 13.25C15.7298 13.73 16.3798 14 17.0498 14C18.6098 14 19.7998 12.63 19.5798 11.09ZM8.99982 6H6.99982V8H5.99982V6H3.99982V5H5.99982V3H6.99982V5H8.99982V6ZM12.9998 5C12.4498 5 11.9998 4.55 11.9998 4C11.9998 3.45 12.4498 3 12.9998 3C13.5498 3 13.9998 3.45 13.9998 4C13.9998 4.55 13.5498 5 12.9998 5ZM14.9998 8C14.4498 8 13.9998 7.55 13.9998 7C13.9998 6.45 14.4498 6 14.9998 6C15.5498 6 15.9998 6.45 15.9998 7C15.9998 7.55 15.5498 8 14.9998 8Z'
        fill='#323232'
      />
    </svg>
  ),
  ExperienceGameIcon: () => (
    <svg
      width='18'
      height='22'
      viewBox='0 0 18 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM16 20H2V4H4V7H14V4H16V20Z'
        fill='#323232'
      />
    </svg>
  ),
  GameOrdersIcon: () => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13 5.5V0H7V5.5L10 8.5L13 5.5ZM5.5 7H0V13H5.5L8.5 10L5.5 7ZM7 14.5V20H13V14.5L10 11.5L7 14.5ZM14.5 7L11.5 10L14.5 13H20V7H14.5Z'
        fill='#323232'
      />
    </svg>
  ),
  OrderIcon: () => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 6.5H15V4.5H10V6.5ZM10 13.5H15V11.5H10V13.5ZM16 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H16C17.1 0 18 0.9 18 2V16C18 17.1 17.1 18 16 18ZM3 8H8V3H3V8ZM4 4H7V7H4V4ZM3 15H8V10H3V15ZM4 11H7V14H4V11Z'
        fill='#323232'
      />
    </svg>
  ),
  SupplierIcon: () => (
    <svg
      width='22'
      height='19'
      viewBox='0 0 22 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 13H16V10H17V8L16 3H1L0 8V10H1V16H10V10H14V13ZM8 14H3V10H8V14Z'
        fill='#323232'
      />
      <path d='M16 0H1V2H16V0Z' fill='#323232' />
      <path d='M19 14V11H17V14H14V16H17V19H19V16H22V14H19Z' fill='#323232' />
    </svg>
  ),
  GameIcon: () => (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M9 0L3.5 9H14.5L9 0Z' fill='#323232' />
      <path
        d='M14.5 20C16.9853 20 19 17.9853 19 15.5C19 13.0147 16.9853 11 14.5 11C12.0147 11 10 13.0147 10 15.5C10 17.9853 12.0147 20 14.5 20Z'
        fill='#323232'
      />
      <path d='M0 11.5H8V19.5H0V11.5Z' fill='#323232' />
    </svg>
  ),
};
